import { AnsweringClient } from "../clients/answeringClient";

export interface IAssignmentMetadata {
  type: string;
  backEnabled: boolean;
  consentTermId: number;
  description: string;
  instructions: string;
  lastAnsweredQuestion: number;
  title: string;
  totalQuestions: number;
  allow_audio: boolean;
}

export interface InstructionsControllerDelegate {
  didGetAssignmentToken(token: string): void;
  didGetAssignmentMetadata(metadata: IAssignmentMetadata): void;
  applicationShouldLogout(): void;
  genericError(message?: string): void;
}

export class InstructionsController {

  constructor (
    private delegate: InstructionsControllerDelegate,
    private readonly answeringClient = new AnsweringClient()
  ) { }

  public async getAssignmentToken(accessToken: string, instrumentId: string) {
    try {
      const assignmentToken = await this.answeringClient.getInstrumentToken(accessToken, instrumentId);
      const data = assignmentToken.data;
      this.delegate.didGetAssignmentToken(data.token);
    } catch (error: any) {
      if(error?.response?.status === 403) {
        const newTokens = await this.refreshTokens();
        if(!newTokens) {
          return;
        }
        this.getAssignmentToken(newTokens.accessToken, instrumentId);
        return;
      }
      this.delegate.genericError(this.extractErrorMessage(error));
    }
  }

  public async getAssignmentMetadata(accessToken: string, assignmentToken: string) {
    try {
      const metadata = await this.answeringClient.getInstrumentMetadata(accessToken, assignmentToken);
      const data = metadata.data;
      this.delegate.didGetAssignmentMetadata(data);
    } catch (error: any) {
      if(error?.response?.status === 403) {
        const newTokens = await this.refreshTokens();
        if(!newTokens) {
          return;
        }
        this.getAssignmentMetadata(newTokens.accessToken, assignmentToken);
        return;
      }
      this.delegate.genericError(this.extractErrorMessage(error));
    }
  }

  private async refreshTokens(): Promise<{accessToken: string, refreshToken: string} | void> {
    const refreshToken = localStorage.getItem("RefreshToken");
    if(!refreshToken) {
      this.delegate.applicationShouldLogout();
      return;
    }
    try {
      const response = await this.answeringClient.refreshToken(refreshToken);
      const tokens: {accessToken: string, refreshToken: string} = response.data;
      localStorage.setItem("AccessToken", tokens.accessToken);
      localStorage.setItem("RefreshToken", tokens.refreshToken);
      return tokens;
    } catch (error: any) {
      this.delegate.applicationShouldLogout();
      return;
    } 
  }

  private extractErrorMessage(error: any): string | undefined {
    return (
      error?.response?.data?.message ||
      error?.response?.data?.error ||
      error?.message
    );
  }
}
